import { cn } from "./UI";
import {
  User,
  Building2,
  FolderKanban,
  CreditCard,
  Shield,
  Bell,
  Headphones,
  FileText,
  AlertTriangle,
} from "lucide-react";

const menuItems = [
  { id: "profile", label: "Profile", icon: User, ownerOnly: false },
  { id: "company", label: "Company", icon: Building2, ownerOnly: true },
  // { id: "projects", label: "Projects", icon: FolderKanban },
  { id: "billing", label: "Billing & Plan", icon: CreditCard, ownerOnly: true },
  { id: "security", label: "Security", icon: Shield, ownerOnly: false },
  // { id: "notifications", label: "Notifications", icon: Bell },
  { id: "support", label: "Support", icon: Headphones, ownerOnly: true },
  { id: "legal", label: "Legal", icon: FileText, ownerOnly: false },
  {
    id: "danger",
    label: "Danger Zone",
    icon: AlertTriangle,
    ownerOnly: false,
  },
];

export function SettingsSidebar({ activeSection, onSectionChange }) {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const isOwner = user.profession === "owner";
  return (
    <div className="w-64 flex-shrink-0">
      <div className="sticky top-6 ">
        <h2 className="text-xl font-semibold text-primary-text mb-6 px-3">
          Settings
        </h2>
        <nav className="space-y-1">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => onSectionChange(item.id)}
              className={cn(
                "w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200",
                activeSection === item.id
                  ? "bg-sm-primary/10 text-sm-primary border-l-2 border-sm-primary"
                  : "text-text-gray hover:bg-gray-bg hover:text-primary-text",
                item.id === "danger" &&
                  "text-destructive hover:text-destructive hover:bg-destructive/10",
                item.ownerOnly && !isOwner && "hidden",
              )}
            >
              <item.icon
                className={cn(
                  "h-4 w-4",
                  activeSection === item.id && "text-sm-primary",
                  item.id === "danger" && "text-destructive",
                )}
              />
              {item.label}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
}
